import styled from "styled-components";
import { EditorTabs } from "./AIHumansEditor";

interface Props {
  data: {
    value: EditorTabs;
    label: string;
  }[];
  active: EditorTabs;
  handleTabsChange: (value: EditorTabs) => void;
}

const AIHumansEditorTabs = ({ data, active, handleTabsChange }: Props) => {
  return (
    <Row>
      <Tabs>
        {data.map(({ value, label }) => (
          <Tab key={value} active={value === active} onClick={() => handleTabsChange(value)}>
            {label}
          </Tab>
        ))}
      </Tabs>
    </Row>
  );
};

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryBackground1};
  width: fit-content;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-inline: 4px;
`;

const Tab = styled.div<{ active: boolean }>`
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
  letter-spacing: -0.404119px;
  opacity: 0.6;
  color: ${({ theme }) => theme.primaryText};
  padding: 10px;
  cursor: pointer;

  ${({ active, theme }) =>
    active &&
    `
        border-bottom: 2px solid ${theme.activeMenu};
        opacity: 1;
    `}
`;

const ButtonWrapper = styled.div`
  position: relative;
  margin-left: auto;

  button {
    gap: 4px;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  input[type="file"],
  input[type="file"]::-webkit-file-upload-button {
    cursor: pointer;
  }
`;

export default AIHumansEditorTabs;
